<script>
import proofView from "../components/review/proofView.v2.vue";
import {
  HubConnectionBuilder,
  LogLevel,
  HttpTransportType,
} from "@microsoft/signalr";
import approverResponseModal from "../components/review/modals/modal-approver-response";
import Vue from "vue";
import VueRandomColor from "vue-randomcolor";
import approverRegistrationModal from "../components/review/modals/approverRegistrationModal";
import proofPasswordGateModal from "../components/review/modals/proofPasswordGateModal";
import navigationBeforeDecisionModal from "../components/review/modals/navigationBeforeDecisionModal";
import portalPromptModal from "../components/review/modals/portalPromptModal";
import ProofViewCompareNavigation from "../components/review/proof-view-compare-navigation";
import ProofChangeTimeline from "../components/review/proof-change-timeline.vue";
import moment from "moment";
import { isEqual } from "lodash";
import { PROOF_VIEW_MODES } from "../utils/constants";

const { PROOF_OWNER_MODE, COMMENTER_MODE, APPROVER_MODE } = PROOF_VIEW_MODES;
const ViewMode = {
  Review: 1,
  Compare: 2,
};
const defaultFileProperties = {
  startedLoading: 0,
  loaded: false,
  zoom: 1,
  zoomMode: 0,
  height: 0,
  zoomHeight: 0,
  rotation: 0,
  width: 0,
  zoomWidth: 0,
  player: {
    curPlayerTime: 0,
  },
  pdf: {
    totalPages: 0,
    curPage: 0,
    pageToView: 1,
  },
  element: null,
  curTimer: "",
};
const CONNECTION_EVENTS = {
    CONNECTED : "Connected",
    DISCONNECTED: "Disconnected",
    RECONNECTED: "Reconnected"
};
const { CONNECTED, DISCONNECTED, RECONNECTED } = CONNECTION_EVENTS;
Vue.use(VueRandomColor);
Vue.mixin({
  // beforeRouteLeave (to, from , next) {
  //   // const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
  //   // if (answer) {
  //   //   next()
  //   // } else {
  //   //   next(false)
  //   // }
  // }
})

export default {
  components: {
    ProofViewCompareNavigation,
    ProofChangeTimeline,
    proofView,
    approverResponseModal,
    navigationBeforeDecisionModal,
    approverRegistrationModal,
    proofPasswordGateModal,
    portalPromptModal,
  },
  props: {
    publicId: {
      required: true,
      type: String,
    },
    approverPublicId: {
      type: String,
    },
    curAccount: {
      required: true,
      type: Object,
    },
    requiresPassword: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      curFile: null,
      curProof: null,
      curDisplayLang: "En",
      curLang: "en-us",
      accessDeniedMessage: "",
      accessDenied: true,
      curUser: null,
      activeUsers: {},
      activeUsersList: [],
      activeUserInactivityInMinutes: 3,
      proofEvents: [],
      curApprover: null,
      pendingApproverPublicId: null,
      mode: -1, // 1 = Agency Review Screen, 0 = Approver Review Screen, 2 = Reviewer Only Screen
      viewMode: ViewMode.Review,
      initialProof: null,
      approverIpAddress: "",
      alertMessage: "",
      alertType: "success",
      scrollAnimationRootTask: null,
      scrollAnimationTask: null,
      approverFeedback: null,
      decisionSubmitInFlight: false,
      approverSkipped: false,
      realTimeConnection: null,
      realTimeCursorConnection: null,
      realTimeHeartbeatTimer: null,
      inactivityTimeout: null,
      inactivityTimeoutAfter: 600000, // 10 mins,
      isDisconnectedDueToInactivity: false,
      isConnecting: false,
      isCursorConnecting: false,
      isMobile: window.innerWidth < 701,
      identityRetryAttempted: false,
      reviewVersionId: 0,
      compareVersionId: 0,
      connectedUsers: [],
      // change tracking (revision diff) state
      changeTracking: null,
      changeTrackingRequestedPair: null,
      changeTrackingPollTimer: null,
      changeTrackingPollStartedAt: 0,
      timelineScopedFileId: null,
      timelineCollapsed: false,
      pairingInFlight: false,
      pendingPairJob: null,
    };
  },
  async created() {
  },
  async mounted() {
    let self = this;

    window.onresize = this.refreshIsMobile();

    self.logOutChannel = new BroadcastChannel('logoutChannel');

    self.logOutChannel.addEventListener('message', (event) => {
      if (event.data === 'logout') {
        //close the tab
        window.close();
      }
    });

    window.addEventListener('keydown', function (e) {
      if (e.key === ' ' && e.target === document.body) {
        e.preventDefault();
      }
    });

    this.ConnectToReviewHub();

    if (document.getElementById("hubspot-messages-iframe-container") !== null) {
      let a = document.getElementById("hubspot-messages-iframe-container");
      a.parentElement.removeChild(a);
    }

    this.$root.$on("alert::user", (message, type, timeout) => {
      if (timeout === undefined) {
        timeout = 5000;
      }
      self.alertMessage = message;
      self.alertType = type;
      setTimeout(function () {
        self.alertMessage = "";
        self.alertType = "success";
      }, timeout);
    });
    this.$root.$on("api::working", () => {
      self.loadingData = true;
    });
    this.$root.$on("api::idle", () => {
      self.loadingData = false;
    });
    this.$root.$on("review::unauthorized", this.handleUnauthorized);

    this.approverIpAddress = await this.$A.ReviewService.WhoAmI();

    this.loadUserLang();
    await this.$A.LangService.loadLanguage(this.curAccount.id);

    if (!this.$A.viewToViewData) await this.LoadViewData();

    if (this.$A.viewToViewData !== null && this.$A.viewToViewData.proof !== undefined && this.approverPublicId === undefined) {
      this.accessDenied = false;
      this.mode = PROOF_OWNER_MODE;
      this.curUser = this.$A.Auth;
      const authToken = _.get(this, '$A.Auth.apiToken.token', "");
      await this.setReviewProof({ proofId: this.$A.viewToViewData.proof.id });
      await this.RegisterRealTimeConnection(
          authToken,
          this.publicId
      );
    } else {
      this.mode = APPROVER_MODE;
      await this.GetApproverIdentity();
    }

    this.loadCustomStyle();

    window.onresize = () => {
      self.resize();
    }
    window.addEventListener('beforeunload', this.preventNavBeforeDecision);
  },
  methods: {
    LoadViewData: async function () {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      if (this.$A.Auth !== null) {
        let proof = await this.$A.ProofService.GetProofFromPubId(this.publicId);
        this.$A.viewToViewData = {
          proof: proof
        }
        if (params.tl) { // checking to see if the token used was valid and the user was logged in. else act like normal link
          let clean_uri = location.protocol + "//" + location.host + location.pathname;
          window.history.replaceState({}, document.title, clean_uri);
        }
      }
    },
    ConnectToReviewHub: function () {
    },
    RealtimeHeartbeat: function () {
      let self = this;
      if (this.isDisconnectedDueToInactivity || this.isConnecting) return;
      // Clear the existing timer
      clearTimeout(this.realTimeHeartbeatTimer);
      // Start a new timer
      this.realTimeHeartbeatTimer = setTimeout(function () {
        try {
          self.realTimeConnection.invoke("HeartBeat");
        } catch (e) {
          console.log("Error sending heartbeat:", e);
        }
        self.filterActiveUsers();
        self.RealtimeHeartbeat();
      }, 1000 * 10)
    },
    resetInactivityTimeout() {
      let self = this;
      // Clear the existing timer
      clearTimeout(this.inactivityTimeout);
      // Start a new timer
      this.inactivityTimeout = setTimeout(() => {
        self.isDisconnectedDueToInactivity = true;
        self.realTimeConnection.stop().then(() => {
          console.log("Review hub disconnected due to inactivity.");
          clearTimeout(self.realTimeHeartbeatTimer);
        }).catch(err => {
          console.error("Error disconnecting:", err);
        });
        self.realTimeCursorConnection.stop().then(() => {
          console.log("Cursor hub disconnected due to inactivity.");
        }).catch(err => {
          console.error("Error disconnecting:", err);
        });
      }, self.inactivityTimeoutAfter);
    },
    RegisterRealTimeCursorConnection: async function () {
      if (this.realTimeCursorConnection !== null) return;
      this.realTimeCursorConnection = this.$A.RealtimeCursorService.Connect();

      // ReceiveUserCursorUpdate
      this.realTimeCursorConnection.on("ReceiveUserCursorUpdate", async (userCursor) => {
        let self = this;
        const targetId = (userCursor.approverId) ? `a:${userCursor.approverId}` : `u:${userCursor.userId}`;

        if (_.get(self.activeUsers, `${targetId}.targetX`) == userCursor.x &&
          _.get(self.activeUsers, `${targetId}.targetY`) == userCursor.y &&
          _.get(self.activeUsers, `${targetId}.zoom`) == userCursor.zoom &&
          _.get(self.activeUsers, `${targetId}.zoomMode`) == userCursor.zoomMode &&
          _.get(self.activeUsers, `${targetId}.rotation`) == userCursor.rotation) {
          return;
        }

        self.activeUsers[targetId] = Object.assign(self.activeUsers[targetId] || {}, { ...userCursor, targetId });
        self.activeUsersList = Object.values(self.activeUsers);
        await self.filterActiveUsers();
        await self.updateUsersPointer(_.get(self.activeUsers, `${targetId}`));
      });

      // ReceiveAudioVideoTimelineCursorUpdate
      this.realTimeCursorConnection.on("ReceiveAudioVideoTimelineCursorUpdate", async (userCursor) => {
        // user audio-video cursor update
        // console.log(userCursor)
      });

      this.startCursorConnection()
    },
    startCursorConnection: async function () {
      if (this.isCursorConnecting) return;

      try {
        this.isCursorConnecting = true;
        await this.realTimeCursorConnection.start();

        console.log("realtime cursor connected.");
        this.isCursorConnecting = false;
        if(this.curProof) {
          const groupInfo = {
            accountId: this.curProof.accountId,
            proofId: this.curProof.id,
          }
          await this.realTimeCursorConnection.invoke("AddToGroup", groupInfo);
        }
      } catch (err) {
        console.error("Error connecting to realtime cursor hub:", err);
        setTimeout(this.startCursorConnection, 5000); // Retry connection after 5 seconds
      }
    },
    RegisterRealTimeConnection: async function (token, publicId, approverPublicId) {
      let self = this;
      if (this.realTimeConnection !== null || !token) {
        return;
      }
      this.realTimeConnection = this.$A.RealtimeService.Connect();

      //ReadyForRegistration
      this.realTimeConnection.on("ReadyForRegistration", async () => {
        try {
          await self.realTimeConnection.invoke(
              "RegisterReviewerConnection",
              token,
              publicId,
              "reviewPage"
          );
          if (approverPublicId)
            await self.realTimeConnection.invoke(
                "LogLocalIdentity",
                JSON.stringify(window.$A.LoadDataCache(`approver_keychain_${publicId}_${approverPublicId}`, true))
            );
        } catch (err) {
          console.error(err);
        }
      });

      //Registered
      this.realTimeConnection.on("Registered", async () => {
        self.RealtimeHeartbeat()
      });

      //ReconnectRequest
      this.realTimeConnection.on("ReconnectRequest", async (ipAddress) => {
        //reconnect real time at address
        //if fails after 3 attempts connect to api again.
        // console.log(ipAddress)
      });

      //PresenceUpdate
      this.realTimeConnection.on("PresenceUpdate", async (users) => {
        const ids = {};
        users.forEach(u => {
          const targetId = (u.approverId) ? `a:${u.approverId}` : `u:${u.userId}`;
          ids[targetId] = true;

          self.activeUsers[targetId] = Object.assign(self.activeUsers[targetId] || {}, u);
        });

        Object.keys(self.activeUsers).forEach(id => {
          if (!ids[id]) {
            delete self.activeUsers[id];
          }
        });

        self.activeUsersList = Object.values(self.activeUsers);
        await self.filterActiveUsers();
      });

      //ReceiveProofEvents
      this.realTimeConnection.on("ReceiveProofEvents", async (appEvent) => {
        const createdByCurrentUser = (appEvent.appEventObject.approverId === _.get(self.curApprover, 'id', -1) ||
            appEvent.appEventObject.userId === _.get(self.curUser, 'id', -1));

        // console.log("appEvent", appEvent);
        // if event created by same user do not include
        if (appEvent.eventType !== 34 && createdByCurrentUser) {
          return;
        }

        let proofVersionId = _.get(appEvent, 'appEventObject.commentAnnotation.proofVersionId');
        let fileId = _.get(appEvent, 'appEventObject.commentAnnotation.proofFileId');
        let comment = _.get(appEvent, 'appEventObject.commentAnnotation');
        let commentId = _.get(comment, 'id');
        let file = _.get(self.curProof, 'currentVersion.versionFiles', []).find(f => f.id === fileId);
        let isCurrentVersion = proofVersionId === _.get(self.curProof, 'currentVersion.id');
        let approver = _.get(appEvent, 'appEventObject.approver', null);
        let user = _.get(appEvent, 'appEventObject.user', null);
        const userId = _.get(appEvent, 'appEventObject.userId', 0);
        const approverId = _.get(appEvent, 'appEventObject.approverId', 0);

        switch (appEvent.eventType) {
          case 34: {
            // The event carries a ProofVersion, but versionIds holds
            // ProofVersionIndex entries — map it across (and move the
            // current-version flag) so version-aware UI keeps working
            const createdVersion = _.get(appEvent, 'appEventObject.proofVersionCreated', {});
            self.curProof.versionIds.forEach(v => {
              v.isCurrentVersion = false;
            });
            self.curProof.versionIds.push({
              proofVersionId: _.get(createdVersion, 'id', 0),
              versionNumber: _.get(createdVersion, 'versionNumber', 0),
              isCurrentVersion: true,
              isHiddenFromApproversAndReviewers: false,
            });
            if (!createdByCurrentUser) {
              self.proofEvents.push({
                ...appEvent.appEventObject,
                event: 'Created New Version'
              });
            }
            break;
          }
          case 38:
            if (userId && user) {
              const engagedUsers =  _.get(self, 'curProof.engagedUsers', []);
              _.set(appEvent, 'appEventObject.user.color', self.$refs.proofView.getColor(userId));
              engagedUsers.push(appEvent.appEventObject.user);
              _.set(self, 'curProof.engagedUsers', engagedUsers);
            } else if (approverId && approver) {
              _.set(appEvent, 'appEventObject.approver.color', self.$refs.proofView.getColor(approverId));
              if (approver.approverType === 2) {
                const reviewers = _.get(self, 'curProof.currentVersion.currentStage.reviewers', []);
                reviewers.push(approver);
                _.set(self, 'curProof.currentVersion.currentStage.reviewers', reviewers);
              } else {
                const approvers = _.get(self, 'curProof.currentVersion.currentStage.approvers', [])
                approvers.push(approver);
                _.set(self, 'curProof.currentVersion.currentStage.approvers', approvers);
              }
            }

            break;
          case 39:
            const files = _.get(appEvent, 'appEventObject.filesApprovalStatus', []);
            const approvedFiles = files.filter(f => f.approved);
            const approvedWithChangesFiles = files.filter(f => f.approvedWithChanges);
            const notApprovedFiles = files.filter(f => !f.approved && !f.approvedWithChanges);
            let messages = [];
            if (approvedFiles.length) {
              messages.push(`${approvedFiles.length} file(s) approved`);
            }
            if (approvedWithChangesFiles.length) {
              messages.push(`${approvedWithChangesFiles.length} file(s) approved with changes`);
            }
            if (notApprovedFiles.length) {
              messages.push(`${notApprovedFiles.length} file(s) not approved`);
            }

            this.shouldShowNotifications() && self.proofEvents.push({
              ...appEvent.appEventObject,
              event: messages.join(', ')
            });
            break;
          case 45:
            // self.proofEvents.push({
            //   ...appEvent.appEventObject,
            //   event: 'Added a comment'
            // });
            if (isCurrentVersion && file) {
              file.proofFileAnnotations = file.proofFileAnnotations || [];
              file.proofFileAnnotations.push(comment);
            }
            break;
          case 49:
          case 50:
          case 51:
            if (appEvent.eventType === 49) {
              this.shouldShowNotifications(appEvent) && self.proofEvents.push({
                ...appEvent.appEventObject,
                event: 'Added a comment'
              });
            }
            if (isCurrentVersion && file) {
              if (appEvent.appEventObject.deletedCommentId) {
                comment.proofFileAnnotationComments = comment.proofFileAnnotationComments.filter(c => c.id !== appEvent.appEventObject.deletedCommentId);
              }
              file.proofFileAnnotations = file.proofFileAnnotations.map(a => {
                if (a.id === commentId) {
                  return comment;
                }
                return a;
              });
              if (!comment.proofFileAnnotationComments.length) {
                file.proofFileAnnotations = file.proofFileAnnotations.filter(a => a.id !== commentId);
              }
            }
            break;
          case 62:
            const { file : newFile, proofVersionId } = _.get(appEvent, 'appEventObject', {});
            const shouldUpdateVersionFiles =  _.get(self, 'curProof.currentProofVersionId', 0) === proofVersionId;
            if (!shouldUpdateVersionFiles) break;
            const updatedFile = {
              ...newFile,
              ...defaultFileProperties,
            };
            let newProof = { ...self.curProof };
            const curFileIndex = _.findIndex(_.get(newProof, 'currentVersion.versionFiles', []), { id: updatedFile.id });

            if (curFileIndex !== -1) {
              _.set(newProof, `currentVersion.versionFiles[${curFileIndex}]`, {
              ..._.get(newProof, `currentVersion.versionFiles[${curFileIndex}]`, {}),
              ...updatedFile,
              });
            } else {
              let currentVersionFiles = _.get(newProof, 'currentVersion.versionFiles', []);
              currentVersionFiles.push(updatedFile);
              _.set(newProof, "currentVersion.versionFiles", currentVersionFiles);
            }
            
            let proofEvents = _.get(newProof, 'proofEvents', []);
            proofEvents.push(appEvent);
            _.set(newProof, "proofEvents", proofEvents);

            await self.setReviewProof({ proof: newProof });

            break;
        }
      });
      //Start connection
      await this.startConnection();
    },
    startConnection: async function () {
      if (this.isConnecting) return;
      
      try {
        this.isConnecting = true;
        await this.realTimeConnection.start();
        console.log("realtime Connected.");

        this.isConnecting = false;
        if (this.isDisconnectedDueToInactivity) {
          this.startCursorConnection()
          this.isDisconnectedDueToInactivity = false;
          return;
        }

        await this.RegisterRealTimeCursorConnection();
      } catch (err) {
        console.error("Error connecting to realtime review hub:", err);
        setTimeout(this.startConnection, 5000); // Retry connection after 5 seconds
      }
    },
    filterActiveUsers: async function () {
      let self = this;
      this.activeUsersList = this.activeUsersList
          .filter(u => this.curProof != null && u.proofId === this.curProof.id)
          .filter(u => !u.lastHeartbeat ||
              moment(u.lastHeartbeat).add(this.activeUserInactivityInMinutes, "minute").isAfter(moment())
          );

      if (!self.curProof) return;

      // add users in active list but not in engaged users
      this.activeUsersList.forEach(user => {
        self.curProof.engagedUsers = self.curProof.engagedUsers || [];
        const engagedUserIds = Object.fromEntries(self.curProof.engagedUsers.map(u => [u.userId, true]));
        if (user.userId && !engagedUserIds[user.userId] && user.userId !== _.get(self.curUser, 'id')) {
          user.color = self.$refs.proofView.getColor(user.userId);
          user.id = user.userId;
          self.curProof.engagedUsers.push(user);
        }
      });

      // remove engaged users not in active list
      this.curProof.engagedUsers = this.curProof.engagedUsers || [];
      const activeIds = Object.fromEntries(this.activeUsersList.map(u => [u.userId, true]));
      this.curProof.engagedUsers = this.curProof.engagedUsers.filter(u => activeIds[u.id] || u.id === _.get(this.curUser, 'id'));
    },
    // Smoothly update the user pointer
    updateUsersPointer: async function (user) {
      if (user.approverId === _.get(this.curApprover, 'id', -1) ||
          user.userId === _.get(this.curUser, 'id', -1)) {
        return;
      }
      this.$root.$emit("cursor_position_update", user);
    },
    sendRealtimeCursorUpdate: async function (cursorUpdate) {
      if (this.isCursorConnecting) return;
      if (this.isDisconnectedDueToInactivity) {
        await this.startConnection();
        await this.reloadProof();
        this.resetInactivityTimeout();
        return;
      }
      this.resetInactivityTimeout();
      // do not send update if only user connected
      if (this.activeUsersList.length < 2) return;
      // do not send update if in compare mode
      if (this.isCompareMode) return;
      this.realTimeCursorConnection.invoke("BroadcastMousePosition", cursorUpdate);
    },
    sendRealtimeAudioVideoTimelineCursorUpdate: async function (cursorUpdate) {
      // do not send update if in compare mode
      if (this.isCompareMode) return;
      this.realTimeCursorConnection.invoke("BroadcastAudioVideoTimelineCursorUpdate", cursorUpdate);
    },
    handleUnauthorized: async function () {
      // The server rejected our approver token mid-flow. Re-establish identity
      // once from scratch (the review URL still carries the approver id); if
      // that also fails, end at access denied — never the app login screen.
      if (this.mode === PROOF_OWNER_MODE) return;
      if (this.identityRetryAttempted) {
        this.accessDenied = true;
        this.accessDeniedMessage = "This review link is no longer active.";
        return;
      }
      this.identityRetryAttempted = true;
      this.$A.ReviewService.ClearApproverIdentity(this.publicId);
      this.curApprover = null;
      await this.GetApproverIdentity();
    },
    GetApproverIdentity: async function () {
      const curApproverPublicId = this.approverPublicId || this.$A.LoadDataCache(`approver_id_${this.publicId}`, true);
      if (this.requiresPassword && curApproverPublicId) {
        // Returning approver (workflow email link or cached identity) on a
        // password-protected proof: collect the password before loading them in
        this.pendingApproverPublicId = curApproverPublicId;
        this.accessDenied = false;
        this.$refs.proofPasswordGateModal.open();
        return;
      }
      await this.$A.ReviewService.TryToGetApproverIdentity(this.publicId, curApproverPublicId)
          .then(this.handleApproverRegistered)
    },
    handleProofPasswordValidated: async function (password) {
      await this.$A.ReviewService.TryToGetApproverIdentity(this.publicId, this.pendingApproverPublicId, password)
          .then(this.handleApproverRegistered)
    },
    handleApproverRegistered: async function (approverIdentity) {
      if (approverIdentity !== null && approverIdentity.error !== undefined) {
        this.accessDeniedMessage = approverIdentity.error;
        this.accessDenied = true;
        return;
      }
      if (approverIdentity === "accessDenied") {
        this.accessDenied = true;
        this.accessDeniedMessage = "Access Denied";
        return;
      } else {
        this.accessDenied = false;
      }

      if (approverIdentity === null) {
        this.$refs.approverRegistrationModal.open();
        return;
      }

      if (approverIdentity.workflowStageApproverStatus !== undefined) {
        // load approver feedback result if the stage is the same and the approver did have feedback

        if (approverIdentity.approverType == 2) {
          this.mode = COMMENTER_MODE;
        }

        let statusCode = approverIdentity.workflowStageApproverStatus;

        if (statusCode === 6) {
          this.approverSkipped = true;
          this.approverFeedback = {
            approvalChoice: -1,
            feedBackText: "",
            filesApprovalStatus: [],
          };
        } else if (statusCode <= 2) {
          this.approverFeedback = null;
        } else if (statusCode > 2) {
          this.approverFeedback = {
            approvalChoice: statusCode === 3 ? 0 : statusCode === 4 ? 1 : 2,
            feedBackText: "",
            filesApprovalStatus: [],
          };
        }
      }

      this.$A.ReviewService.SetLoggedInApprover(approverIdentity);
      this.$A.Auth = {account: this.curAccount};
      this.curApprover = approverIdentity;
      await this.LoadViewData();
      const loadedProof = _.get(this, "$A.viewToViewData.proof", null);
      if (!loadedProof) {
        // proof fetch failed (e.g. token rejected); degrade to access denied
        // instead of throwing mid-boot
        this.accessDenied = true;
        this.accessDeniedMessage = "We couldn't load this proof.";
        return;
      }
      await this.setReviewProof({ proofId: loadedProof.id });

      this.$A.SaveDataCache(`approver_id_${this.publicId}`, approverIdentity.publicId , 90, true);

      await this.RegisterRealTimeConnection(
          approverIdentity.token,
          this.publicId,
          approverIdentity.publicId
      );
    },
    handleApproverResponse: async function (approverResponse) {
      // an individual-files submission (mode 3) may be partial — hold off
      // locking the review until the server says the response is final, but
      // block re-entry while a submission is in flight
      if (this.decisionSubmitInFlight) {
        return;
      }
      this.decisionSubmitInFlight = true;
      const isIndividualSubmit = approverResponse.approvalChoice === 3;
      if (!isIndividualSubmit) {
        this.approverFeedback = approverResponse;
      }
      let status = approverResponse.approvalChoice;

      // approve indv. files then override
      // > 1 ApprovedWithChanges  => ApprovedWithChanges
      // > 1 not approved => not approved
      if (
          approverResponse.filesApprovalStatus !== undefined &&
          approverResponse.filesApprovalStatus.length > 0
      ) {
        let indvFiles = approverResponse.filesApprovalStatus;

        let approvedWithChangesCounter = 0;
        let notApprovedCounter = 0;

        for (let i = 0; i < indvFiles.length; i++) {
          if (indvFiles[i].approvedWithChanges) {
            approvedWithChangesCounter++;
          }
          if (!indvFiles[i].approved && !indvFiles[i].approvedWithChanges) {
            notApprovedCounter++;
          }
        }

        // map to server side ids (server: client modal mode)
        // 5=2 ApprovedWithChanges
        // 4=1 Approved
        // 3=0 NotApproved

        if (notApprovedCounter > 0) {
          approverResponse.approvalStatus = 3;
        } else if (approvedWithChangesCounter > 0) {
          approverResponse.approvalStatus = 5;
        } else {
          approverResponse.approvalStatus = 4;
        }
      } else {
        // map to server side ids (server: client modal mode)
        // 5=2 ApprovedWithChanges
        // 4=1 Approved
        // 3=0 NotApproved
        approverResponse.approvalStatus =
            status === 0 ? 3 : status === 1 ? 4 : 5;
      }

      window.scrollTo(0, 0);
      let response;
      try {
        response = await this.$A.ReviewService.ProcessApproverDecision(
            approverResponse
        );
      } finally {
        this.decisionSubmitInFlight = false;
      }
      if (response && response.success) {
        const result = _.get(response, "data", null);
        if (isIndividualSubmit && result && result.recorded === false) {
          // the server dropped this submission (response already finalized or
          // nothing decidable) — don't report success or overwrite local state
          this.$A.AlertUser(
              `${this.getLabel('approver_decision_modal_labels', 'approver_alert_after_submit')}`,
              "warning",
              10000
          );
          return;
        }
        if (isIndividualSubmit && result && result.recorded && !result.finalized) {
          // partial save — the approver can come back and decide the rest
          const undecided = result.undecidedFileNames || [];
          this.$A.AlertUser(
              `Your decisions have been saved. ${undecided.length} file${undecided.length === 1 ? " has" : "s have"} not received a review yet.`,
              "success",
              10000
          );
          // keep the modal reopenable and remember the saved choices locally
          this.approverFeedback = null;
          const decisions = (approverResponse.filesApprovalStatus || []).map((f) => ({
            proofVersionFileId: f.fileId,
            decision: f.approvedWithChanges ? 2 : 1,
          }));
          const existing = (this.curApprover && this.curApprover.fileDecisions) || [];
          const merged = existing.filter((d) => !decisions.some((n) => n.proofVersionFileId === d.proofVersionFileId)).concat(decisions);
          this.$set(this.curApprover, "fileDecisions", merged);
          return;
        }
        if (isIndividualSubmit) {
          this.approverFeedback = approverResponse;
          this.$refs.approverResponseModal.markResponseFinalized();
        }
        this.$A.AlertUser(
            `${this.getLabel('approver_decision_modal_labels', 'approver_confirm_alert')}`,
            "success",
            10000
        );
        this.$refs.portalPromptModal.showIfEligible();
      } else {
        if (isIndividualSubmit) {
          this.approverFeedback = null;
        }
        this.$A.AlertUser(
            `${this.getLabel('approver_decision_modal_labels', 'approver_error_alert')}`,
            "warning",
            10000
        );
      }
    },
    preventNavBeforeDecision: function (e) {
      if (this.approverFeedback === null && this.mode === APPROVER_MODE) {
        e.preventDefault();
        this.$refs.navigationBeforeDecisionModal.open();
        e.returnValue = new Date();
        return new Date();
      }
    },
    setReviewProof: async function ({ proofId, proofVersion = 0, proof }) {
      let self = this;
      let interval = setInterval(async function () {
        if (self.$refs.proofView) {
          clearInterval(interval);
          const pane = self.$refs.proofView;
          const curProofVersion = proof ? proof.currentVersion.id : proofVersion;
          // the pane already shows the requested version: wiping pane.proof
          // here would force a refetch whose SetCurrentProof lands later and
          // resets file selection + pdf.pageToView under the user's feet
          // (change-click navigation snapped back to page 1 / first file)
          if (
            !proof &&
            curProofVersion &&
            _.get(pane, "proof.currentProofVersionId", 0) === curProofVersion &&
            _.get(pane, "proof.currentVersion")
          ) {
            return;
          }
          pane.proof = {
            id: proof ? proof.id : proofId
          };
          await pane.viewProofVersion(curProofVersion, proof);
        }
      }, 50)
    },
    setCompareProof: async function (proofId, proofVersion = 0) {
      let self = this;
      let interval = setInterval(async function () {
        if (self.$refs.compareProofView) {
          clearInterval(interval);
          const pane = self.$refs.compareProofView;
          // same guard as setReviewProof: no wipe/refetch when the pane is
          // already on the requested version
          if (
            proofVersion &&
            _.get(pane, "proof.currentProofVersionId", 0) === proofVersion &&
            _.get(pane, "proof.currentVersion")
          ) {
            return;
          }
          pane.proof = {
            id: proofId
          };
          await pane.viewProofVersion(proofVersion);
        }
      }, 50)
    },
    // flips the layout into compare mode without loading any version into the
    // compare pane — used by change-tracking navigation which immediately
    // sets both panes to the tracked version pair itself (loading the default
    // pair here too would race a second fetch/reset against that navigation)
    enterCompareViewMode: function () {
      this.viewMode = ViewMode.Compare;
      this.$nextTick(() => {
        const canvasElement = document.querySelector('.canvas-container');
        if (canvasElement) {
          this.$refs.proofView.updateZoom(1);
        }
      });
    },
    switchToCompareViewMode: async function () {
      this.enterCompareViewMode();
      let proofVersion = this.curProof.versionIds[this.curProof.versionIds.length - 2].proofVersionId;
      await this.setCompareProof(this.$refs.proofView.proof.id, proofVersion);
    },
    switchToReviewViewMode: function () {
      this.viewMode = ViewMode.Review;
    },
    setCurFile(file) {
      this.curFile = file;
    },
    setCurProof(proof) {
      this.curProof = proof;
      this.initChangeTracking();
    },
    // --- change tracking (revision diffs) ---
    initChangeTracking: function () {
      // Smart Review is gated to standard+ plans and an account opt-in; the server
      // resolves both into curAccount.smartReviewAvailable (owner and reviewer alike).
      // When off, never fetch, poll, or render change tracking.
      if (!_.get(this.curAccount, "smartReviewAvailable", false)) return;
      // fetch current-vs-previous on load whenever the proof has >= 2 versions
      // (same default pair compare mode uses: versionIds[len-2] vs the last)
      const versions = _.get(this.curProof, "versionIds", []);
      if (!Array.isArray(versions) || versions.length < 2) return;
      const fromVersionId = _.get(versions[versions.length - 2], "proofVersionId", 0);
      const toVersionId = _.get(versions[versions.length - 1], "proofVersionId", 0);
      if (!fromVersionId || !toVersionId) return;
      const pair = fromVersionId + ":" + toVersionId;
      if (this.changeTrackingRequestedPair === pair) return;
      this.changeTrackingRequestedPair = pair;
      this.changeTracking = null;
      this.stopChangeTrackingPoll();
      this.changeTrackingPollStartedAt = Date.now();
      this.fetchChangeTracking(fromVersionId, toVersionId);
    },
    fetchChangeTracking: async function (fromVersionId, toVersionId) {
      let result = null;
      try {
        result = await this.$A.ChangeTrackingService.fetch({
          curUser: this.curUser,
          curApprover: this.curApprover,
          proofId: _.get(this.curProof, "id", 0),
          fromVersionId: fromVersionId,
          toVersionId: toVersionId,
        });
      } catch (e) {
        console.log("change tracking fetch failed", e);
      }
      // a newer pair was requested while this call was in flight
      if (this.changeTrackingRequestedPair !== fromVersionId + ":" + toVersionId) return;
      if (!result) {
        // endpoint unavailable or errored — leave badges/timeline empty
        this.stopChangeTrackingPoll();
        return;
      }
      this.changeTracking = result;
      if (this.hasPendingChangeTrackingJobs(result)) {
        this.scheduleChangeTrackingPoll(fromVersionId, toVersionId);
      } else {
        this.stopChangeTrackingPoll();
      }
    },
    hasPendingChangeTrackingJobs: function (changeTracking) {
      if (!changeTracking) return false;
      if (changeTracking.status === "queued" || changeTracking.status === "processing") return true;
      return _.get(changeTracking, "jobs", []).some(
        (j) => j.status === "queued" || j.status === "processing"
      );
    },
    scheduleChangeTrackingPoll: function (fromVersionId, toVersionId) {
      // poll every 2.5s while jobs are queued/processing, give up after 2 min
      if (Date.now() - this.changeTrackingPollStartedAt > 120000) return;
      clearTimeout(this.changeTrackingPollTimer);
      const self = this;
      this.changeTrackingPollTimer = setTimeout(function () {
        self.fetchChangeTracking(fromVersionId, toVersionId);
      }, 2500);
    },
    stopChangeTrackingPoll: function () {
      clearTimeout(this.changeTrackingPollTimer);
      this.changeTrackingPollTimer = null;
    },
    // badge click: jump into compare mode with the version pair set, the
    // paired files selected in both panes and the timeline scoped to the file
    // Compare mode is strictly "this file, before and after": when the user
    // changes the file in either pane, re-scope the rail to that file's diff
    // pair AND switch the other pane to its counterpart. Overlapping switches
    // are serialized through a last-wins queue (pairingInFlight/pendingPairJob)
    // so interleaved runs can't land the panes on a mismatched pair.
    handlePaneFileChanged: async function (side, file) {
      if (!this.isCompareMode || !file || !this.changeTracking) return;
      const summaries = this.changeTrackingSummaries;
      // exact id lookups first — the byName fallback keeps only the last job
      // per filename and must never pre-empt an id match
      let job = summaries.byId[file.id] ? summaries.byId[file.id].job : null;
      if (!job && side === "left") {
        job = _.get(this.changeTracking, "jobs", []).find(
          (j) => j.fromProofVersionFileId === file.id
        ) || null;
      }
      if (!job) {
        const byName = summaries.byName[(file.name || "").toLowerCase()];
        job = byName ? byName.job : null;
      }
      // -1 (matches no job) scopes the rail to a quiet empty state for files
      // with no comparison, instead of falling back to the all-files list
      this.timelineScopedFileId = job ? job.toProofVersionFileId : -1;
      if (!job) return;
      // last-wins queue: overlapping pane switches would otherwise interleave
      // reviewFile calls and land the panes on a mismatched pair
      this.pendingPairJob = job;
      if (this.pairingInFlight) return;
      this.pairingInFlight = true;
      try {
        while (this.pendingPairJob && this.isCompareMode) {
          const next = this.pendingPairJob;
          this.pendingPairJob = null;
          await this.selectChangeTrackingFiles(next);
        }
      } finally {
        this.pairingInFlight = false;
        this.pendingPairJob = null;
      }
    },
    openChangeTrackingForFile: async function (file) {
      const changeTracking = this.changeTracking;
      if (!changeTracking) return;
      const summaries = this.changeTrackingSummaries;
      const summary =
        summaries.byId[file.id] ||
        summaries.byName[(file.name || "").toLowerCase()];
      const job = summary ? summary.job : null;
      if (!this.isCompareMode) {
        this.enterCompareViewMode();
      }
      this.timelineScopedFileId = job ? job.toProofVersionFileId : null;
      // left pane = from (older) version, right pane = to (newer) version
      await this.setReviewVersionId(changeTracking.fromVersionId);
      await this.setCompareVersionId(changeTracking.toVersionId);
      if (job) {
        await this.selectChangeTrackingFiles(job);
      }
    },
    // waits for a pane to finish loading the requested proof version
    waitForPaneVersion: function (refName, versionId) {
      const self = this;
      return new Promise(function (resolve) {
        const startedAt = Date.now();
        const check = function () {
          const pane = self.$refs[refName];
          if (
            pane &&
            _.get(pane, "proof.currentProofVersionId", 0) === versionId &&
            _.get(pane, "proof.currentVersion")
          ) {
            return resolve(pane);
          }
          if (Date.now() - startedAt > 15000) return resolve(null);
          setTimeout(check, 100);
        };
        check();
      });
    },
    waitForPaneFile: function (pane, fileId) {
      return new Promise(function (resolve) {
        const startedAt = Date.now();
        const check = function () {
          if (_.get(pane, "curFile.id") === fileId) return resolve(true);
          if (Date.now() - startedAt > 5000) return resolve(false);
          setTimeout(check, 50);
        };
        check();
      });
    },
    selectChangeTrackingFiles: async function (job) {
      const changeTracking = this.changeTracking;
      if (!changeTracking) return { leftPane: null, rightPane: null };
      const panes = await Promise.all([
        this.waitForPaneVersion("proofView", changeTracking.fromVersionId),
        this.waitForPaneVersion("compareProofView", changeTracking.toVersionId),
      ]);
      const leftPane = panes[0];
      const rightPane = panes[1];
      // a call can survive compare-mode exit (waitForPaneVersion resolves
      // null after its timeout) — never switch the review pane's file then
      if (!this.isCompareMode) return { leftPane: null, rightPane: null };
      const findFile = function (pane, fileId, fileName) {
        const files = _.get(pane, "proof.currentVersion.versionFiles", []);
        let file = fileId ? files.find((f) => f.id === fileId) : undefined;
        if (!file && fileName) {
          file = files.find(
            (f) => (f.name || "").toLowerCase() === String(fileName).toLowerCase()
          );
        }
        return file;
      };
      let leftFile = null;
      let rightFile = null;
      if (rightPane) {
        rightFile = findFile(rightPane, job.toProofVersionFileId, job.fileName);
        if (rightFile && _.get(rightPane, "curFile.id") !== rightFile.id) {
          rightPane.reviewFile(rightFile);
        }
      }
      if (leftPane) {
        leftFile = findFile(leftPane, job.fromProofVersionFileId, job.fileName);
        if (leftFile && _.get(leftPane, "curFile.id") !== leftFile.id) {
          leftPane.reviewFile(leftFile);
        }
      }
      if (rightPane && rightFile) await this.waitForPaneFile(rightPane, rightFile.id);
      if (leftPane && leftFile) await this.waitForPaneFile(leftPane, leftFile.id);
      return { leftPane: leftPane, rightPane: rightPane };
    },
    // pdf.totalPages is populated as a render side-effect after a file
    // switch, so briefly retry instead of silently skipping the page jump
    // when the pane has only just swapped files
    goToPanePage: function (pane, pageNumber) {
      return new Promise(function (resolve) {
        const attempt = function (triesLeft) {
          const totalPages = _.get(pane, "curFile.pdf.totalPages", 0);
          const currentPage = _.get(pane, "curFile.pdf.pageToView", 0);
          if (!(pageNumber > 0)) return resolve(false);
          if (totalPages > 0) {
            if (pageNumber <= totalPages && currentPage !== pageNumber) {
              pane.GoToPage(pageNumber);
              return resolve(true);
            }
            return resolve(false);
          }
          if (triesLeft <= 0) return resolve(false);
          setTimeout(function () {
            attempt(triesLeft - 1);
          }, 100);
        };
        attempt(20);
      });
    },
    // timeline card click: open both panes exactly at the diff — enter
    // compare mode when needed (sidebar clicks in review mode), jump both
    // panes to the change's page pair, fit the whole page in each viewport
    // for full context, then pulse the highlight on the change region
    handleChangeSelected: async function (payload) {
      await this.navigateToChange(payload);
    },
    navigateToChange: async function (payload) {
      const change = payload.change;
      const page = payload.page;
      const job = payload.job;
      const changeTracking = this.changeTracking;
      if (!changeTracking) return { leftPane: null, rightPane: null };
      if (!this.isCompareMode) {
        this.enterCompareViewMode();
      }
      // make sure the panes hold the tracked pair (left = older, right =
      // newer) — a manually opened compare view defaults to the reverse order
      await this.setReviewVersionId(changeTracking.fromVersionId);
      await this.setCompareVersionId(changeTracking.toVersionId);
      const panes = await this.selectChangeTrackingFiles(job);
      const leftPane = panes.leftPane;
      const rightPane = panes.rightPane;
      if (rightPane && page.toPageNumber) await this.goToPanePage(rightPane, page.toPageNumber);
      if (leftPane && page.fromPageNumber) await this.goToPanePage(leftPane, page.fromPageNumber);
      if (!change) return panes;
      const box = {
        x: change.xPct,
        y: change.yPct,
        w: change.widthPct,
        h: change.heightPct,
      };
      // let the page swap kick off before waiting on the new page image
      await new Promise((resolve) => setTimeout(resolve, 400));
      // coords are relative to the after-page raster; mirror the box on the
      // before pane too when the pages are an aligned pair
      if (rightPane && page.toPageNumber) {
        await rightPane.fitPageOnRegion(box);
        rightPane.flashChangeHighlight(box);
      }
      if (leftPane && page.fromPageNumber && !page.pageChangeType) {
        await leftPane.fitPageOnRegion(box);
        leftPane.flashChangeHighlight(box);
      }
      return panes;
    },
    resize: function () {
      this.$refs.proofView.resize();
      // if (this.isCompareMode) this.$refs.compareProofView.resize();
    },
    loadCustomStyle: function () {
      if (this.curAccount && this.curAccount.css) {
        let css = document.createElement("style");
        css.setAttribute("type", "text/css");
        css.innerHTML = this.curAccount.css;
        document.head.appendChild(css);
      }
    },
    getLabel: function (section, key) {
      return this.$A.LangService.getLabel(section, key);
    },
    setUserLang: function (lang) {
      this.$A.LangService.setUserLang(lang);
      this.loadUserLang();
      window.removeEventListener('beforeunload', this.preventNavBeforeDecision);
      window.location.reload();
    },
    loadUserLang: function () {
      this.curLang = this.$A.LangService.getUserLang();
      this.curDisplayLang = (this.curLang === 'es-us') ? 'Es' : 'En';
    },
    refreshIsMobile: function () {
      this.isMobile = window.innerWidth < 701;
    },
    captureApproverResponse: function (mode) {
      if (_.get(this.curProof, 'archived')) {
        $A.AlertUser('Proof Is Locked')
        return;
      }
      if (this.approverSkipped) {
        $A.AlertUser('This stage has been approved. Your response is no longer needed.')
        return;
      }
      // Decisions always apply to the latest version; block them while an
      // older version is on screen (the nav shows Go to Latest Version instead)
      if (this.versions.length > 1 && this.latestVersionId
          && _.get(this.curProof, 'currentProofVersionId') !== this.latestVersionId) {
        $A.AlertUser('You are viewing a previous version. Go to the latest version to make your decision.')
        return;
      }
      if (this.decisionSubmitInFlight) {
        return;
      }
      this.$refs.approverResponseModal.open(mode, this.approverFeedback);
    },
    handleReviewVersion: function (versionId) {
      this.reviewVersionId = versionId;
    },
    handleCompareVersion: function (versionId) {
      this.compareVersionId = versionId;
    },
    setReviewVersionId: async function (versionId) {
      await this.setReviewProof({ proofId: this.curProof.id, proofVersion: versionId });
    },
    setCompareVersionId: async function (versionId) {
      await this.setCompareProof(this.curProof.id, versionId);
    },
    reloadProof: async function () {
      await this.$refs.proofView.viewProofVersion(this.curProof.currentVersion.id);
    },
    getEventDefaultFields: function (user) {
      return {
        user,
        commentAnnotation: null,
        userId: user.userId,
        approverId: user.approverId,
        appEventType: null,
        proofVersionCreated: { id: null },
        triggeredAt: Date.now(),
      };
    },
    getUserId: function (user) {
      return user.approverId || user.userId;
    },
    shouldShowNotifications: function (user) {
      const allowViewAllComments = this.curProof.allowViewAllComments || this.curUser;
      if (!user) return !!allowViewAllComments;
      return !!allowViewAllComments || !!user.userId;
    }
  },
  computed: {
    showApprovedButton: function () {
      if (this.curProof === null) {
        return false;
      }
      if (this.allowApproveIndividualFiles) {
        return false;
      }

      if (!this.curApprover) return false;

      if (this.curProof.allowApproveWithChanges) {
        for (let i = 0; i < this.curProof.currentVersion.versionFiles.length; i++) {
          let vf = this.curProof.currentVersion.versionFiles[i];

          if (vf.proofFileAnnotations && vf.proofFileAnnotations.length > 0) {
            let annotationsByCurApprover = vf.proofFileAnnotations.filter(annotation => annotation.approverId === this.curApprover.id && annotation.proofFileAnnotationComments.length > 0);
            return annotationsByCurApprover.length === 0;
          }
        }
      }
      return true;
    },
    commentFileApi: function () {
      if (
          this.curProof &&
          this.curProof !== null &&
          this.curProof !== undefined &&
          this.curProof !== null
      ) {
        let apiUrl = "/annotation/comment-file/" + this.curProof.publicId;
        if (this.curUser !== null) {
          apiUrl += "?u=" + _.get(this, 'curUser.apiToken.token', '');
        }
        if (this.curApprover !== null) {
          apiUrl += "?a=" + _.get(this, 'curApprover.token', '');

        }
        return apiUrl;
      }
      return "";
    },
    allowApproveIndividualFiles: function () {
      return this.curProof !== null &&
      this.curProof.allowApproveIndividualFiles !== undefined
          ? this.curProof.allowApproveIndividualFiles
          : false;
    },
    curLogo: function () {
      return this.curAccount !== null &&
      this.curAccount.whiteLabelEnabled &&
      this.curAccount.whiteLabelLogoUri !== "" &&
      this.curAccount.whiteLabelLogoUri !== null
          ? this.curAccount.whiteLabelLogoUri
          : "https://high-seas.s3.amazonaws.com/email/logo.svg";
    },
    isReviewMode: function () {
      return this.viewMode === ViewMode.Review;
    },
    isCompareMode: function () {
      return this.viewMode === ViewMode.Compare;
    },
    versions: function () {
      return _.get(this.curProof, 'versionIds', []);
    },
    // per-file badge summaries keyed by toProofVersionFileId (byId) with a
    // fileName fallback (byName); files absent from both maps show no badge.
    // Thumbnail badge states: "unchanged" (muted chip) and "analyzing" only —
    // files with detected changes signal through the sidebar's compare callout.
    changeTrackingSummaries: function () {
      const summaries = { byId: {}, byName: {} };
      const changeTracking = this.changeTracking;
      if (!changeTracking || !Array.isArray(changeTracking.jobs)) return summaries;
      changeTracking.jobs.forEach(function (job) {
        let state = null;
        if (job.status === "queued" || job.status === "processing") {
          state = "analyzing";
        } else if (job.status === "complete") {
          state = job.normalChangeCount > 0 ? "changes" : "unchanged";
        } else if (job.status === "skipped" && job.skipReason === "unchanged") {
          state = "unchanged";
        }
        // failed and skipped (ambiguous/unsupported/missing rasters) → no badge
        if (!state) return;
        const summary = {
          state: state,
          normalChangeCount: job.normalChangeCount,
          minorChangeCount: job.minorChangeCount,
          tooltip: state === "unchanged" ? "No changes in this version" : "",
          job: job,
        };
        if (job.toProofVersionFileId) summaries.byId[job.toProofVersionFileId] = summary;
        if (job.fileName) summaries.byName[String(job.fileName).toLowerCase()] = summary;
      });
      return summaries;
    },
    latestVersionId: function () {
      const versions = this.versions;
      if (!versions.length) return 0;
      return _.get(versions[versions.length - 1], "proofVersionId", 0);
    },
    // Persistent in compare mode whenever there is something to show — not
    // dismissable. A comparison where nothing changed (every file unchanged,
    // skipped, or unsupported, nothing still analyzing) hides the rail
    // entirely rather than presenting a column of non-results.
    timelineRailHasContent: function () {
      const jobs = _.get(this.changeTracking, "jobs", []);
      return jobs.some(function (job) {
        return (
          job.status === "queued" ||
          job.status === "processing" ||
          (job.normalChangeCount || 0) > 0 ||
          (job.minorChangeCount || 0) > 0 ||
          (Array.isArray(job.pages) && job.pages.length > 0)
        );
      });
    },
    showTimelineRail: function () {
      return (
        this.isCompareMode &&
        !!this.changeTracking &&
        !this.isMobile &&
        this.timelineRailHasContent
      );
    },
    reviewPaneClass: function () {
      if (!this.isCompareMode) return "col-12 p-0";
      return this.showTimelineRail
        ? "compare-pane-with-rail px-0 position-relative"
        : "col-lg-6 col-sm-12 px-0 position-relative";
    },
    comparePaneClass: function () {
      return this.showTimelineRail
        ? "compare-pane-with-rail pl-0 position-relative"
        : "col-lg-6 col-sm-12 pl-0 position-relative";
    },
  },
  beforeDestroy() {
    this.stopChangeTrackingPoll();
    this.$root.$off("review::unauthorized", this.handleUnauthorized);
  },
  watch: {
    activeUsersList(newActiveUsers, prevActiveUsers) {
      if (isEqual(prevActiveUsers, newActiveUsers)) return;

      const getUserId = this.getUserId.bind(this);
      const prevActiveUserIds = new Set(prevActiveUsers.map(getUserId));
      const newActiveUserIds = new Set(newActiveUsers.map(getUserId));
      const connectedUserIds = new Set(this.connectedUsers.map(getUserId));

      const currentUser = this.curApprover || this.curUser;

      const currentUserFromEvent = newActiveUsers.find(
        (user) => getUserId(user) === currentUser.id
      );

      newActiveUsers.forEach((user) => {
        const userId = getUserId(user);
        const isUserPrevConnected = connectedUserIds.has(userId);
        const isNewActiveUser = !prevActiveUserIds.has(userId);
        const isCurrentUser = currentUser.id === userId;

        if (isCurrentUser) return;

        const event = isUserPrevConnected ? RECONNECTED : CONNECTED;

        const isRecentlyConnectedUser = currentUserFromEvent && new Date(user.connectedAt) > new Date(currentUserFromEvent.connectedAt);

        if (isRecentlyConnectedUser && isNewActiveUser) {
          this.shouldShowNotifications(user) && this.proofEvents.push({
            ...this.getEventDefaultFields(user),
            event,
          });
        }
      });

      prevActiveUsers.forEach((user) => {
        const userId = getUserId(user);
        const isUserActive = newActiveUserIds.has(userId);
        const isCurrentUser = currentUser.id === userId;

        if (!isUserActive && !isCurrentUser) {
          this.shouldShowNotifications(user) && this.proofEvents.push({
            ...this.getEventDefaultFields(user),
            event: DISCONNECTED,
          });
        }
      });

      this.activeUsersList.forEach((activeUser) => {
        const activeUserId = getUserId(activeUser);
        const index = _.findIndex(
          this.connectedUsers,
          (user) => getUserId(user) === activeUserId
        );

        if (index === -1) this.connectedUsers.push(activeUser);
        else this.connectedUsers[index] = activeUser;
      });
    },
  },
};
</script>

<template>
  <div>
    <b-alert
        :variant="alertType"
        id="nav-alert"
        class="nav-alert m-0"
        :show="alertMessage.length > 0"
        dismissible
    >
      <span v-html="alertMessage"></span>
    </b-alert>
    <proof-view-compare-navigation
        v-if="isCompareMode"
        :avatar="curLogo"
        :versions="versions"
        :left-cur-version-id="reviewVersionId"
        :right-cur-version-id="compareVersionId"
        @switch-to-review="switchToReviewViewMode"
        @on-left-version-change="setReviewVersionId"
        @on-right-version-change="setCompareVersionId"
    />
    <div style="overflow-x: hidden;" class="row m-0">
      <div ref="review-version" :class="reviewPaneClass">
        <proof-view label="review"
                    ref="proofView"
                    :mode="mode"
                    :view-mode="viewMode"
                    :cur-user="curUser"
                    :actives="activeUsersList"
                    :events="proofEvents"
                    :cur-logo="curLogo"
                    :cur-approver="curApprover"
                    :cur-account="curAccount"
                    :cur-lang="curLang"
                    :public-id="publicId"
                    :approver-feedback="approverFeedback"
                    :approver-skipped="approverSkipped"
                    :approver-public-id="approverPublicId"
                    :access-denied="accessDenied"
                    :access-denied-message="accessDeniedMessage"
                    :is-review-mode="isReviewMode"
                    :is-compare-mode="isCompareMode"
                    :comment-file-api="commentFileApi"
                    :cur-display-lang="curDisplayLang"
                    :show-approved-button="showApprovedButton"
                    :change-tracking-summary="changeTrackingSummaries"
                    :change-tracking="changeTracking"
                    v-on:proofLoaded="setCurProof($event)"
                    v-on:curFileChanged="setCurFile($event)"
                    @file-changed="handlePaneFileChanged('left', $event)"
                    @change-badge-selected="openChangeTrackingForFile"
                    @change-selected="handleChangeSelected"
                    @on-set-lang="setUserLang"
                    @on-response="captureApproverResponse"
                    @on-compare="switchToCompareViewMode"
                    @cursor-update="sendRealtimeCursorUpdate"
                    @on-audio-video-cursor-update="sendRealtimeAudioVideoTimelineCursorUpdate"
                    @version-changed="handleReviewVersion"
        />
      </div>
      <div ref="compare-version" v-if="isCompareMode" :class="comparePaneClass">
        <proof-view label="compare"
                    ref="compareProofView"
                    :mode="mode"
                    :view-mode="viewMode"
                    :cur-user="curUser"
                    :actives="activeUsersList"
                    :events="proofEvents"
                    :cur-approver="curApprover"
                    :cur-account="curAccount"
                    :public-id="publicId"
                    :cur-lang="curLang"
                    :approver-feedback="approverFeedback"
                    :approver-public-id="approverPublicId"
                    :access-denied="accessDenied"
                    :access-denied-message="accessDeniedMessage"
                    :is-review-mode="isReviewMode"
                    :is-compare-mode="isCompareMode"
                    :comment-file-api="commentFileApi"
                    @version-changed="handleCompareVersion"
                    @file-changed="handlePaneFileChanged('right', $event)"
        />
      </div>
      <!-- change-tracking timeline rail -->
      <div v-if="showTimelineRail" class="change-timeline-rail border-left border-gray-100"
           :class="{ 'change-timeline-rail--collapsed': timelineCollapsed }">
        <proof-change-timeline
            :change-tracking="changeTracking"
            :scoped-file-id="timelineScopedFileId"
            :collapsed="timelineCollapsed"
            @toggle-collapsed="timelineCollapsed = !timelineCollapsed"
            @change-selected="handleChangeSelected"
        />
      </div>
      <!-- Modals -->
      <navigationBeforeDecisionModal ref="navigationBeforeDecisionModal"/>
      <portalPromptModal ref="portalPromptModal"
                         :account="curAccount"
                         :approver="curApprover"
      />
      <approverResponseModal ref="approverResponseModal"
                             v-on:approverResponded="handleApproverResponse($event)"
                             :proof="curProof"
                             :account="curAccount"
                             :commentApiUrl="commentFileApi"
                             :saved-file-decisions="(curApprover && curApprover.fileDecisions) || []"
                             :allow-partial-submit="true"
      />
      <approverRegistrationModal ref="approverRegistrationModal"
                                 :public-proof-id="publicId"
                                 :requires-password="requiresPassword"
                                 v-on:onapproverregistered="handleApproverRegistered($event)"
      />
      <proofPasswordGateModal ref="proofPasswordGateModal"
                              :public-proof-id="publicId"
                              v-on:onpasswordvalidated="handleProofPasswordValidated($event)"
      />
    </div>
  </div>
</template>

<style scoped>
#nav-alert {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  min-height: 40px;
  z-index: 99999999;
}
/* compare panes shrink from col-lg-6 to equal flex shares when the
   change-timeline rail is open */
.compare-pane-with-rail {
  flex: 1 1 0;
  min-width: 0;
  position: relative;
}
.change-timeline-rail {
  flex: 0 0 340px;
  width: 340px;
  max-width: 340px;
  transition: flex-basis 150ms ease, width 150ms ease, max-width 150ms ease;
  height: 100vh;
  position: sticky;
  top: 0;
  background-color: #F9F9F9; /* matches .bg-ashore-white header surfaces */
  z-index: 1200;
  /* the rail is a fixed viewport-height column; only its change list
     scrolls — never the page */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.change-timeline-rail > .change-timeline {
  flex: 1 1 auto;
  min-height: 0;
}
.change-timeline-rail--collapsed {
  flex: 0 0 44px;
  width: 44px;
  max-width: 44px;
}
@media (prefers-reduced-motion: reduce) {
  .change-timeline-rail { transition: none; }
}
</style>

